import React from 'react';
import '../assets/css/Section.css';

export default function Section() {
  return (
    <>
      <div className="section">
        <div class="container">
          <h4>
            <b>John Doe</b>
          </h4>
          <p>Architect & Engineer</p>
        </div>
      </div>
    </>
  );
}
